if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        this.productVariants = [];
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.loadProductVariants();
        
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          this.updateVariantId();
          this.updatePrice();
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      loadProductVariants() {
        const form = this.closest('form');
        if (!form) return;

        const variantScript = form.querySelector('script[type="application/json"]');
        if (variantScript) {
          try {
            this.productVariants = JSON.parse(variantScript.textContent);
          } catch (e) {
            console.error('Failed to parse product variants:', e);
          }
        }
      }

      updateVariantId() {
        const form = this.closest('form');
        if (!form) return;

        const hiddenIdInput = form.querySelector('input[name="id"]');
        if (!hiddenIdInput) return;

        const selectedOptions = Array.from(this.querySelectorAll('fieldset input[type="radio"]:checked')).map(
          (input) => input.value
        );

        const matchedVariant = this.findVariantBySelectedOptions(selectedOptions);

        if (matchedVariant) {
          hiddenIdInput.value = matchedVariant.id;
        }
      }

      updatePrice() {
        const form = this.closest('form');
        if (!form) return;

        const matchedVariant = this.getSelectedVariant();
        if (!matchedVariant) return;

        const priceElement = form.querySelector('[role="status"] [id*="price"]');
        if (priceElement) {
          const sectionId = form.id.replace('product-form-', '');
          const url = `${window.location.pathname}?variant=${matchedVariant.id}&section_id=${sectionId}`;
          
          fetch(url)
            .then(res => res.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const newPrice = doc.querySelector('[role="status"]');
              if (newPrice) {
                priceElement.closest('[role="status"]').innerHTML = newPrice.innerHTML;
              }
            })
            .catch(err => console.error('Price update failed:', err));
        }
      }

      getSelectedVariant() {
        const selectedOptions = Array.from(this.querySelectorAll('fieldset input[type="radio"]:checked')).map(
          (input) => input.value
        );
        return this.findVariantBySelectedOptions(selectedOptions);
      }

      findVariantBySelectedOptions(selectedOptions) {
        if (!this.productVariants || this.productVariants.length === 0) return null;

        return this.productVariants.find((variant) => {
          if (!variant.options) return false;
          
          // Vergelijk alleen de opties die er zijn (flexibel voor 2 of 3 opties)
          for (let i = 0; i < selectedOptions.length; i++) {
            if (variant.options[i] !== selectedOptions[i]) {
              return false;
            }
          }
          return true;
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}